import {
  TOGGLE_DIRTY_FORM_ON,
  TOGGLE_DIRTY_FORM_OFF,
  SHOW_BANNER,
  HIDE_BANNER,
  SHOW_MOBILE_MENU,
  HIDE_MOBILE_MENU,
  SET_LAST_EDIT_TIME,
  SHOW_SAVE_ALERT,
  HIDE_SAVE_ALERT,
  SET_ERROR,
  CLEAR_ERROR,
  SET_EXPERIMENTAL_MODE
} from "../actions/types";

/** Cross-cutting UI slice of the store. */
export interface GlobalState {
  isFormDirty: boolean;
  isBannerVisible: boolean;
  bannerType: string | null;
  isMobileMenuVisible: boolean;
  lastEditTime: Date | null;
  isSaveAlertVisible: boolean;
  error: string | null;
  isExperimentalMode: boolean;
}

/** Payload fields the global reducer reads. */
export interface GlobalAction {
  type: string;
  bannerType?: string | null;
  time?: Date | null;
  error?: string | null;
  isExperimental?: boolean;
}

export const initialGlobalState: GlobalState = {
  isFormDirty: false,
  isBannerVisible: false,
  bannerType: null,
  isMobileMenuVisible: false,
  lastEditTime: null,
  isSaveAlertVisible: false,
  error: null,
  isExperimentalMode: false
};

/*
 * Responds to global actions and updates the appropriate state
 */
export function handleGlobalActions(
  state: GlobalState | undefined,
  action: GlobalAction
): GlobalState {
  if (typeof state === "undefined") {
    return initialGlobalState;
  }
  switch (action.type) {
    case TOGGLE_DIRTY_FORM_ON: {
      return Object.assign({}, state, {
        isFormDirty: true
      });
    }
    case TOGGLE_DIRTY_FORM_OFF: {
      return Object.assign({}, state, {
        isFormDirty: false
      });
    }
    case SHOW_BANNER: {
      return Object.assign({}, state, {
        isBannerVisible: true,
        bannerType: action.bannerType ?? null
      });
    }
    case HIDE_BANNER: {
      return Object.assign({}, state, {
        isBannerVisible: false,
        bannerType: null
      });
    }
    case SHOW_MOBILE_MENU: {
      return Object.assign({}, state, {
        isMobileMenuVisible: true
      });
    }
    case HIDE_MOBILE_MENU: {
      return Object.assign({}, state, {
        isMobileMenuVisible: false
      });
    }
    case SET_LAST_EDIT_TIME: {
      return Object.assign({}, state, {
        lastEditTime: action.time ?? null
      });
    }
    case SHOW_SAVE_ALERT: {
      return Object.assign({}, state, {
        isSaveAlertVisible: true
      });
    }
    case HIDE_SAVE_ALERT: {
      return Object.assign({}, state, {
        isSaveAlertVisible: false
      });
    }
    case SET_ERROR: {
      return Object.assign({}, state, {
        error: action.error ?? null
      });
    }
    case CLEAR_ERROR: {
      return Object.assign({}, state, {
        error: null
      });
    }
    case SET_EXPERIMENTAL_MODE: {
      return Object.assign({}, state, {
        isExperimentalMode: action.isExperimental ?? false
      });
    }
    default: {
      return state;
    }
  }
}
